import React from 'react';
import { Row, Col, Layout, message } from 'antd'
import Footer from '../../components/Footer/Footer'
import { validationServices } from "../../services"
import classes from './ValidateRandomization.css'
import ValidationForm from '../../components/ValidateRandomization/ValidateRandomization'
import moment from 'moment'


const { Content } = Layout;


export default class Validation extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            currentStep: 'Step 1',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            randomizationDate: '',
            randomizationGroup: '',
            randomizationWeight: '',
            randomizationTNKDose: '',
            randomizationTPABolusDose: '',
            randomizationTPAInfusionDose: '',
            consentExists: '',
            validationExists: '',
            validationExistsDate: '',
            validationExistsUsedRecommendedValues: '',
            validationExistsDeviationOccurred: '',
            deviationExists: '',
            validationExistsWeight: '',
            validationExistsGroup: '',
            validationExistsTNKDose: '',
            validationExistsTPABolusDose: '',
            validationExistsTPAInfusionDose: '',
            validationExistsComments: '',
            validationExistsOptimizeRegistryID: '',
            validationExistsVialNumber: '',
            validationExistsVialExpiryDate: '',
            validationExistsOverwrite: false,
            validationSaved: false,
            submitted: false,
            loading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVialExpiryDatePickerChange = this.handleVialExpiryDatePickerChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
    }

    handleChange = event => {
      const {name, value} = event.target
      this.setState({
        [name]: value
      })
    }

    handleVialExpiryDatePickerChange = event => {
      this.setState({
        validationExistsVialExpiryDate: event
      })
    }


    handleSubmit(values) {

        this.setState({
            loading: true,
            currentStep: 'Step 4',
            currentStepInt: 4
        });

        validationServices.create(values)
            .then(
                response => {
                    const validationResponse = response.data;


                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        validationExists: false,
                        validationExistsLink: '',
                        validationSaved: false,
                        submitted: false,
                        loading: false
                    });
                });
    }

    handleReset() {
        this.setState({
            currentStep: 'Step 1',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            randomizationDate: '',
            randomizationGroup: '',
            randomizationWeight: '',
            randomizationTNKDose: '',
            randomizationTPABolusDose: '',
            randomizationTPAInfusionDose: '',
            consentExists: '',
            validationExists: '',
            validationExistsDate: '',
            validationExistsUsedRecommendedValues: '',
            validationExistsDeviationOccurred: '',
            validationDeviationExistsComments: '',
            deviationExists: '',
            validationExistsWeight: '',
            validationExistsGroup: '',
            validationExistsTNKDose: '',
            validationExistsTPABolusDose: '',
            validationExistsTPAInfusionDose: '',
            validationExistsComments: '',
            validationExistsOptimizeRegistryID: '',
            validationExistsVialNumber: '',
            validationExistsVialExpiryDate: '',
            validationExistsOverwrite: false,
            validationSaved: false,
            submitted: false,
            loading: false
        })
    }


    handleNext(values) {
      let {currentStep, currentStepInt} = this.state

      if (currentStep === 'Step 1') {
        this.setState({
          loading: true
        })

        validationServices.create(this.state)
            .then(
                response => {
                    const validationResponse = response.data;

                    this.setState({
                        currentStep: 'Step 2',
                        currentStepInt: 2,
                        subjectID: validationResponse['subjectID'],
                        userID: validationResponse['userID'],
                        siteID: validationResponse['siteID'],
                        randomizationDate: validationResponse['randomizationDate'],
                        randomizationGroup: validationResponse['randomizationGroup'],
                        randomizationWeight: validationResponse['randomizationWeight'],
                        randomizationTNKDose: validationResponse['randomizationTNKDose'],
                        randomizationTPABolusDose: validationResponse['randomizationTPABolusDose'],
                        randomizationTPAInfusionDose: validationResponse['randomizationTPAInfusionDose'],
                        consentExists: validationResponse['consentExists'],
                        validationExists: validationResponse['validationExists'],
                        validationExistsDate: validationResponse['validationExistsDate'],
                        validationExistsUsedRecommendedValues: validationResponse['validationExistsUsedRecommendedValues'],
                        deviationExists: validationResponse['deviationExists'],
                        validationExistsDeviationOccurred: validationResponse['validationExistsDeviationOccurred'],
                        validationDeviationExistsComments: validationResponse['validationDeviationExistsComments'],
                        validationExistsWeight: validationResponse['validationExistsWeight'],
                        validationExistsGroup: validationResponse['validationExistsGroup'],
                        saeExists: validationResponse['saeExists'],
                        validationExistsTNKDose: validationResponse['validationExistsTNKDose'],
                        validationExistsTPABolusDose: validationResponse['validationExistsTPABolusDose'],
                        validationExistsTPAInfusionDose: validationResponse['validationExistsTPAInfusionDose'],
                        validationExistsComments: validationResponse['validationExistsComments'],
                        validationExistsOptimizeRegistryID: validationResponse['validationExistsOptimizeRegistryID'],
                        validationExistsVialNumber: validationResponse['validationExistsVialNumber'],
                        validationExistsVialExpiryDate: validationResponse['validationExistsVialExpiryDate'],
                        validationExistsVialExpiryDateMoment:  validationResponse['validationExistsVialExpiryDateUTC'] ? moment.utc(validationResponse['validationExistsVialExpiryDateUTC']).local() : undefined,
                        validationExistsOverwrite: false,
                        validationSaved: false,
                        submitted: false,
                        loading: false

                    });

                    if ( validationResponse['validationExistsVialExpiryDateUTC'] === null ) {
                        this.setState({
                            validationExistsVialExpiryDateMoment: null
                        });
                    }

                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        currentStep: 'Step 1',
                        currentStepInt: 1,
                        subjectID: '',
                        userID: '',
                        siteID: '',
                        randomizationDate: '',
                        randomizationGroup: '',
                        randomizationWeight: '',
                        randomizationTNKDose: '',
                        randomizationTPABolusDose: '',
                        randomizationTPAInfusionDose: '',
                        consentExists: '',
                        validationExists: '',
                        validationExistsDate: '',
                        validationExistsUsedRecommendedValues: '',
                        validationExistsDeviationOccurred: '',
                        validationDeviationExistsComments: '',
                        deviationExists: '',
                        validationExistsWeight: '',
                        validationExistsGroup: '',
                        validationExistsTNKDose: '',
                        validationExistsTPABolusDose: '',
                        validationExistsTPAInfusionDose: '',
                        validationExistsComments: '',
                        validationExistsOptimizeRegistryID: '',
                        validationExistsVialNumber: '',
                        validationExistsVialExpiryDate: '',
                        validationExistsOverwrite: false,
                        validationSaved: false,
                        submitted: false,
                        loading: false
                    })
                });

      } else if (currentStep === 'Step 2')  {
        if ( this.state.validationExistsUsedRecommendedValues === 'true' ) {
            this.setState({
                validationExistsDate: this.state.randomizationDate,
                validationExistsWeight: this.state.randomizationWeight,
                validationExistsGroup: this.state.randomizationGroup,
                validationExistsTNKDose: this.state.randomizationTNKDose,
                validationExistsTPABolusDose: this.state.randomizationTPABolusDose,
                validationExistsTPAInfusionDose: this.state.randomizationTPAInfusionDose
            })
        }

        this.setState({
          currentStep: 'Step 3',
          currentStepInt: 3,
          validationExistsOverwrite: true
        })
      } else if ( (currentStep === 'Step 3') && (this.state.validationExistsOverwrite) && (this.state.validationProvided === 'yes') ) {


        if ( values['validationExistsVialExpiryDate'] !== '' ) {
          values['validationExistsVialExpiryDate'] = moment.utc(values['validationExistsVialExpiryDate'], 'YYYY-MM-DD').local().endOf("month").format('YYYY-MM-DD')
        }

        // window.alert('step 3 submit: DOB: ' + values['dateOfBirth'] + ' .. ' + moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD') + ' .. ' + Date())

        if ( this.state.validationExistsUsedRecommendedValues === 'true' ) {
            this.setState({
                validationExistsDate: this.state.randomizationDate,
                validationExistsWeight: this.state.randomizationWeight,
                validationExistsGroup: this.state.randomizationGroup,
                validationExistsTNKDose: this.state.randomizationTNKDose,
                validationExistsTPABolusDose: this.state.randomizationTPABolusDose,
                validationExistsTPAInfusionDose: this.state.randomizationTPAInfusionDose
            })
        }

        this.setState({
          loading: true
        });

        validationServices.create({...this.state }, values['validationExistsVialExpiryDate'])
            .then(
                response => {
                    const validationResponse = response.data;

                    this.setState({
                        currentStep: 'Step 4',
                        currentStepInt: 4,
                        subjectID: validationResponse['subjectID'],
                        userID: validationResponse['userID'],
                        siteID: validationResponse['siteID'],
                        randomizationDate: validationResponse['randomizationDate'],
                        randomizationGroup: validationResponse['randomizationGroup'],
                        randomizationWeight: validationResponse['randomizationWeight'],
                        randomizationTNKDose: validationResponse['randomizationTNKDose'],
                        randomizationTPABolusDose: validationResponse['randomizationTPABolusDose'],
                        randomizationTPAInfusionDose: validationResponse['randomizationTPAInfusionDose'],
                        consentExists: validationResponse['consentExists'],
                        validationExists: validationResponse['validationExists'],
                        validationExistsDate: validationResponse['validationExistsDate'],
                        validationExistsUsedRecommendedValues: validationResponse['validationExistsUsedRecommendedValues'],
                        deviationExists: validationResponse['deviationExists'],
                        validationExistsDeviationOccurred: validationResponse['validationExistsDeviationOccurred'],
                        validationDeviationExistsComments: validationResponse['validationDeviationExistsComments'],
                        validationExistsWeight: validationResponse['validationExistsWeight'],
                        validationExistsGroup: validationResponse['validationExistsGroup'],
                        validationExistsTNKDose: validationResponse['validationExistsTNKDose'],
                        validationExistsTPABolusDose: validationResponse['validationExistsTPABolusDose'],
                        saeExists: validationResponse['saeExists'],
                        validationExistsTPAInfusionDose: validationResponse['validationExistsTPAInfusionDose'],
                        validationExistsComments: validationResponse['validationExistsComments'],
                        validationExistsOptimizeRegistryID: validationResponse['validationExistsOptimizeRegistryID'],
                        validationExistsVialNumber: validationResponse['validationExistsVialNumber'],
                        validationExistsVialExpiryDate: validationResponse['validationExistsVialExpiryDate'],
                        validationExistsOverwrite: true,
                        validationSaved: true,
                        submitted: false,
                        loading: false
                    });
                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.handleReset()
                });

      } else {
          this.handleReset()
      }

    }

    handlePrev = () => {
      let {currentStep, currentStepInt} = this.state
      if (currentStep === 'Step 2') {
            this.handleReset()
      } else if (currentStep === 'Step 3') {
            this.handleReset()
      }

    }


    render() {
        const { loading, validationSaved } = this.state;

        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <ValidationForm loading={loading} {...this.state} handleChange={this.handleChange} handleVialExpiryDatePickerChange={this.handleVialExpiryDatePickerChange} handleSubmit={this.handleSubmit} handleNext={this.handleNext} handlePrev={this.handlePrev}/>




                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ValidateRandomization/ValidateRandomization.js